export const addToCart = async (
  id,
  quantity,
  data = {},
  serializeExist,
  content
) => {
  const res = await $.ajax({
    url: "/cart/add.js",
    type: "POST",
    dataType: "json",
    data:
      serializeExist == true
        ? $(".product-form").serialize()
        : {
            ...data,
            quantity,
            id,
            properties: content,
          },
  });
  getCart();

  return res;
};

export const addMultipleToCart = async (items, data = {}) => {
  const res = await $.ajax({
    url: "/cart/add.js",
    type: "POST",
    dataType: "json",
    data: {
      ...data,
      items,
    },
  });
  getCart();

  return res;
};

export const getCart = async () => {
  const res = await fetch('/cart.js');

  var event = new CustomEvent("cartUpdated", { detail: res });
  document.dispatchEvent(event);
  return res;
}


export const changeCart = (id, quantity) => {
  return fetch('/cart/change.js', {
    method: 'POST',
    credentials: 'same-origin',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({id,quantity})
  })
}


export const updatecart = (data) => {
  return fetch('/cart/change.js',{
    method: 'POST',
    credentials: 'same-origin',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data)
  })
}
